import { render } from "./messagereply.vue?vue&type=template&id=1c267e54&scoped=true"
import script from "./messagereply.vue?vue&type=script&lang=js"
export * from "./messagereply.vue?vue&type=script&lang=js"

import "./messagereply.vue?vue&type=style&index=0&id=1c267e54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c267e54"

export default script